import { render, staticRenderFns } from "./VPesquisaPlaca.vue?vue&type=template&id=149a6a88&"
import script from "./VPesquisaPlaca.vue?vue&type=script&lang=js&"
export * from "./VPesquisaPlaca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports